<template>
    <div class="profile-page">
        <!-- 顶部信息卡片 -->
        <el-card shadow="always" class="header-card">
            <div class="profile-header">
                <div class="avatar-section">
                    <el-avatar :size="80" :src="avatarPreview">
                        <img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png" />
                    </el-avatar>
                    <div class="avatar-upload">
                        <square-crop-upload
                            v-model="form.avatar"
                            :auto-upload="true"
                            :max-size="1024"
                            ref="avatarUpload"
                        />
                    </div>
                </div>
                <div class="user-summary">
                    <h2 class="nickname">{{ form.nickname || '未设置昵称' }}</h2>
                    <p class="username">@{{ form.username }}</p>
                    <p class="role-info">
                        <el-tag size="small" effect="plain">{{ form.roleMark || '未知角色' }}</el-tag>
                    </p>
                </div>
            </div>
        </el-card>

        <!-- 主体内容 -->
        <el-row :gutter="20" class="main-content">
            <!-- 左侧：基本信息 -->
            <el-col :span="14">
                <el-card shadow="always" class="info-card">
                    <div slot="header" class="card-header">
                        <i class="el-icon-user"></i>
                        <span>基本信息</span>
                    </div>
                    <el-form ref="infoForm" :model="form" :rules="infoRules" label-width="80px" class="info-form">
                        <el-form-item label="账号" prop="username">
                            <el-input v-model="form.username" disabled>
                                <i slot="prefix" class="el-icon-user-solid"></i>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="昵称" prop="nickname">
                            <el-input v-model="form.nickname" maxlength="20" placeholder="请输入昵称">
                                <i slot="prefix" class="el-icon-edit"></i>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="手机号" prop="phone">
                            <el-input v-model="form.phone" maxlength="11" placeholder="请输入手机号">
                                <i slot="prefix" class="el-icon-mobile-phone"></i>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="备注">
                            <el-input v-model="form.remark" type="textarea" :rows="2" maxlength="200" show-word-limit placeholder="个人备注信息"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" :loading="infoLoading" icon="el-icon-check" @click="submitInfo">保存修改</el-button>
                            <el-button @click="resetInfo">重置</el-button>
                        </el-form-item>
                    </el-form>
                </el-card>
            </el-col>

            <!-- 右侧：修改密码 -->
            <el-col :span="10">
                <el-card shadow="always" class="pwd-card">
                    <div slot="header" class="card-header">
                        <i class="el-icon-lock"></i>
                        <span>修改密码</span>
                    </div>
                    <el-form ref="pwdForm" :model="pwdForm" :rules="pwdRules" label-width="80px" class="pwd-form">
                        <el-form-item label="原密码" prop="oldPassword">
                            <el-input v-model="pwdForm.oldPassword" type="password" maxlength="20" show-password placeholder="请输入原密码">
                                <i slot="prefix" class="el-icon-key"></i>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="新密码" prop="newPassword">
                            <el-input v-model="pwdForm.newPassword" type="password" maxlength="20" show-password placeholder="请输入新密码">
                                <i slot="prefix" class="el-icon-lock"></i>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="确认密码" prop="confirmPassword">
                            <el-input v-model="pwdForm.confirmPassword" type="password" maxlength="20" show-password placeholder="请再次输入新密码">
                                <i slot="prefix" class="el-icon-lock"></i>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="warning" :loading="pwdLoading" icon="el-icon-warning" @click="submitPwd">修改密码</el-button>
                        </el-form-item>
                    </el-form>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import SquareCropUpload from '@/components/core/images/SquareCropUpload.vue'
import { reqGetInfo, reqUpdateSysUsers, reqUpdatePwd } from '@/api/system/users'
import global from '@/api/global'

export default {
    name: 'Profile',
    components: { SquareCropUpload },
    data() {
        const validateConfirmPwd = (rule, value, callback) => {
            if (value !== this.pwdForm.newPassword) {
                callback(new Error('两次输入的密码不一致'))
            } else {
                callback()
            }
        }
        const validatePhone = (rule, value, callback) => {
            if (value && !/^1[3-9]\d{9}$/.test(value)) {
                callback(new Error('请输入正确的手机号'))
            } else {
                callback()
            }
        }
        return {
            filePre: global.preview_path_url,
            infoLoading: false,
            pwdLoading: false,
            rawData: {},
            form: {
                id: null,
                avatar: '',
                username: '',
                nickname: '',
                phone: '',
                remark: '',
                roleMark: ''
            },
            infoRules: {
                nickname: [{ required: true, message: '请输入昵称', trigger: 'blur' }],
                phone: [{ validator: validatePhone, trigger: 'blur' }]
            },
            pwdForm: {
                oldPassword: '',
                newPassword: '',
                confirmPassword: ''
            },
            pwdRules: {
                oldPassword: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
                newPassword: [
                    { required: true, message: '请输入新密码', trigger: 'blur' },
                    { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
                ],
                confirmPassword: [
                    { required: true, message: '请再次输入新密码', trigger: 'blur' },
                    { validator: validateConfirmPwd, trigger: 'blur' }
                ]
            }
        }
    },
    computed: {
        avatarPreview() {
            const avatar = this.form.avatar
            if (!avatar) return ''
            if (avatar.startsWith('http') || avatar.startsWith('data:')) return avatar
            if (avatar.startsWith('/')) return avatar
            return this.filePre + avatar
        }
    },
    async created() {
        await this.load()
    },
    methods: {
        async load() {
            try {
                const data = await reqGetInfo()
                this.rawData = { ...data }
                this.form.id = data.id
                this.form.avatar = data.avatar || ''
                this.form.username = data.username || ''
                this.form.nickname = data.nickname || ''
                this.form.phone = data.phone || ''
                this.form.remark = data.remark || ''
                this.form.roleMark = data.roleMark || ''
            } catch (e) {
                this.$message.error('获取用户信息失败')
            }
        },
        async submitInfo() {
            try {
                await this.$refs.infoForm.validate()
            } catch {
                return
            }
            this.infoLoading = true
            try {
                await reqUpdateSysUsers({
                    id: this.form.id,
                    avatar: this.form.avatar,
                    nickname: this.form.nickname,
                    phone: this.form.phone,
                    remark: this.form.remark
                })
                this.$message.success('个人信息修改成功')
                // 更新 store 中的昵称和头像
                this.$store.commit('user/SET_NICK', this.form.nickname)
                if (this.form.avatar) {
                    this.$store.commit('user/SET_AVATAR', this.form.avatar)
                }
                this.rawData = { ...this.form }
            } catch (e) {
                this.$message.error(e.message || '修改失败')
            } finally {
                this.infoLoading = false
            }
        },
        resetInfo() {
            this.form.nickname = this.rawData.nickname || ''
            this.form.phone = this.rawData.phone || ''
            this.form.remark = this.rawData.remark || ''
            this.form.avatar = this.rawData.avatar || ''
            this.$refs.infoForm && this.$refs.infoForm.clearValidate()
        },
        async submitPwd() {
            try {
                await this.$refs.pwdForm.validate()
            } catch {
                return
            }
            this.pwdLoading = true
            try {
                await reqUpdatePwd({
                    userId: this.form.id,
                    oldPassword: this.pwdForm.oldPassword,
                    newPassword: this.pwdForm.newPassword
                })
                this.$message.success('密码修改成功，请重新登录')
                this.pwdForm = { oldPassword: '', newPassword: '', confirmPassword: '' }
                this.$refs.pwdForm && this.$refs.pwdForm.resetFields()
                // 3秒后退出登录
                setTimeout(() => {
                    this.$store.dispatch('user/logout')
                    location.reload()
                }, 2000)
            } catch (e) {
                this.$message.error(e.message || '密码修改失败')
            } finally {
                this.pwdLoading = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.profile-page {
    padding: 20px;
    max-width: 1100px;
    margin: 0 auto;
}

.header-card {
    margin-bottom: 20px;

    .profile-header {
        display: flex;
        align-items: center;
        padding: 10px 0;

        .avatar-section {
            display: flex;
            align-items: center;
            gap: 16px;
            flex-shrink: 0;

            .avatar-upload {
                ::v-deep .preview-box {
                    display: none;
                }
            }
        }

        .user-summary {
            margin-left: 30px;

            .nickname {
                font-size: 22px;
                font-weight: 600;
                color: #303133;
                margin: 0 0 6px 0;
            }

            .username {
                font-size: 14px;
                color: #909399;
                margin: 0 0 6px 0;
            }

            .role-info {
                margin: 0;
            }
        }
    }
}

.card-header {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 600;
    color: #303133;

    i {
        color: #409eff;
        font-size: 18px;
    }
}

.info-card, .pwd-card {
    ::v-deep .el-card__header {
        padding: 14px 20px;
        border-bottom: 1px solid #ebeef5;
    }

    ::v-deep .el-card__body {
        padding: 24px 20px;
    }
}

.info-form, .pwd-form {
    .el-form-item {
        margin-bottom: 20px;

        &:last-child {
            margin-bottom: 0;
            padding-top: 4px;
        }

        ::v-deep .el-input__prefix {
            color: #c0c4cc;
        }

        ::v-deep .el-input.is-disabled .el-input__inner {
            background-color: #f5f7fa;
            color: #909399;
            cursor: not-allowed;
        }
    }
}

.pwd-form {
    .el-button--warning {
        width: 100%;
    }
}
</style>
